// extracted by mini-css-extract-plugin
export default {"message":"Confirmation_message__1CT-z","header":"Confirmation_header__3AVwM","container":"Confirmation_container__1ldWM","main":"Confirmation_main__3E1jZ","restartBtn":"Confirmation_restartBtn__2l_tj","img":"Confirmation_img__3Fdjz","onlyMobile":"Confirmation_onlyMobile__218m6","onlyDesktop":"Confirmation_onlyDesktop__39SqX"};
    if(module.hot) {
      // 1741870133770
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  